import { render, staticRenderFns } from "./etiology.vue?vue&type=template&id=7e8b4f30&scoped=true&"
import script from "./etiology.vue?vue&type=script&lang=js&"
export * from "./etiology.vue?vue&type=script&lang=js&"
import style0 from "./etiology.vue?vue&type=style&index=0&id=7e8b4f30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8b4f30",
  null
  
)

export default component.exports